import '../css/itemslist.css'
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Responsive, Icon, Loader, Button} from 'semantic-ui-react';
import FilterBtn from "./FilterBtn";



export class ItemsList extends Component {



	constructor(props) {
		super(props);
	}

	render() {

		const state = this.props.state;
		
		if(!state.data.length) {
			return (
				<div id="itemslist">
				<Loader active>cargando...</Loader>
				</div>
				)
		}

		state.currentData.sort((a,b)=>{
			if(state.sortedByDistance) {
				return a.distance-b.distance;
			} else {
				if(a.name < b.name) return -1;
				if(a.name > b.name) return 1;
				return 0;
			}
		});

		
		return (
			<div id="itemslist" >

			<div >
			<FilterBtn 
			{...this.props}
			/>
			</div>


			<div id="mylist">
			{
				state.currentData.map((item, i)=>(

					<div key={i}  className="mylistItem">
					

					<Icon name={item.icon.replace("fa-","").replace("-", " ")} style={{color:item.color}} />

					<Link className="link" to={item.path}>
					<div className="header">{item.name}</div>
					<p >{item.preview}</p>
					</Link>

					<Responsive minWidth={768}>
					<p className="distance">{ item.distance ? (item.distance + "km") : " " }</p>
					</Responsive>
					</div>
					))
			}
			</div>
			<div id="itemslistfooter">
			<div>
			<p style={{padding:"11px 0", display:"inline", margin: "0 10px"}}>No encuentras lo que buscas ? </p>
			<Link to="/form"><Button id="agregalobutton">agrégalo a la lista!</Button></Link>
			</div>
		{/*<div>Keep in touch! <Icon name="mail" /></div>*/}
		</div>


		</div>
		);
	}
}

export default ItemsList;


// WEBPACK FOOTER //
// ./src/itemslist/ItemsList.js